import { render, staticRenderFns } from "./SourceMatch.vue?vue&type=template&id=5bd0cb70&"
import script from "./SourceMatch.vue?vue&type=script&lang=js&"
export * from "./SourceMatch.vue?vue&type=script&lang=js&"
import style0 from "./SourceMatch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports